import type { ReactNode } from "react";
import { BookingStatusBadge } from "./BookingStatusBadge";
import { getUpfrontPaidCents } from "./sellerBookingRules";
import { UpfrontPaidDisplay } from "./UpfrontPaidDisplay";
import type { BookingListRow } from "./bookingViewModel";

/** Shared partner-card status badge + upfront paid chip (BookingRowCard / ManageBookingActionCard). */
export function partnerBookingStatusPaid(booking: BookingListRow): {
  statusBadge: ReactNode;
  paidAmount: ReactNode;
} {
  const upfrontPaidCents = getUpfrontPaidCents(booking);
  return {
    statusBadge: (
      <BookingStatusBadge
        status={booking.status}
        handshakeStatus={booking.handshakeStatus}
        partnerView
        size="sm"
      />
    ),
    paidAmount:
      upfrontPaidCents != null ? (
        <UpfrontPaidDisplay
          amountCents={upfrontPaidCents}
          className="text-sm font-semibold text-surface-800"
        />
      ) : null,
  };
}
